<template>
  <v-card
    no-gutter
    style="width: 100% !important; height: 55% !important;"
    class="align-center justify-center text-center"
  >
    <v-card-title class="headline mb-2">
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        v-if="!status.loading"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="connectors"
      :loading="status.loading"
      hide-default-footer
      class="logtable"
      :search="search"
      disable-pagination
    >
      <template v-slot:[`item.active`]="{ item }">
        <v-icon fab :color="getColorByBool(item.active)">
          mdi-check-outline
        </v-icon>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-btn @click="handleClick(item)" icon>
          <v-icon fab color="primary">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ConnectorShow",
  data() {
    return {
      search: "",
      headers: [
        { text: this.$t("connector.field.name"), value: "name" },
        { text: this.$t("connector.field.path"), value: "path" },
        { text: this.$t("connector.field.port"), value: "port" },
        { text: this.$t("connector.field.active"), value: "active" },
        { text: "", value: "action" }
      ]
    };
  },

  computed: {
    ...mapState("connectors", ["connectors", "status"])
  },

  methods: {
    ...mapActions("connectors", ["getByCompany"]),

    getColorByBool(val) {
      return val ? "green" : "error";
    },

    handleClick(item) {
      this.$router.push(`/connectors/edit/${item.backendConnectorId}`);
    }
  },

  async created() {
    await this.getByCompany();
  }
};
</script>
